// Generated by scripts/generate-okta-environments.mjs. Do not edit manually.
export const environment = {
  production: false,
  authenticationRequired: true,
  apiUrl: '/api',
  reviewClientRowsProjectIds: [],
  okta: {
    clientId: '0oa2u9b5jk4Xiqo1U0h8',
    issuer: 'https://labcorp-holdings-dev.oktapreview.com/oauth2/default',
    scopes: ['openid', 'profile', 'email', 'offline_access'],
  },
};
